import React from 'react'

const Destination_Area = () => {
  return (
    <div className="bg-green-400">
      
      <section class="destinations-area bgc-black pt-100 pb-70 rel z-1">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="section-title text-white text-center counter-text-wrap mb-70" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                            <h2>Discover the World's Treasures with Truvz</h2>
                            <p>One site <span class="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience you’ll remember</p>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-xxl-3 col-xl-4 col-md-6">
                        <div class="destination-item" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                            <div class="image">
                                <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                                <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                <img src="https://images.pexels.com/photos/2178175/pexels-photo-2178175.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                            </div>
                            <div class="content">
                                <span class="location"><i class="fal fa-map-marker-alt"></i> Tours, France</span>
                                <h5><a href="/Destination">Brown Concrete Building Basilica St Martin</a></h5>
                                <span class="time">3 days 2 nights - Couple</span>
                            </div>
                            <div class="destination-footer">
                                <span class="price"><span>$58.00</span>/per person</span>
                                <a href="#" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-4 col-md-6">
                        <div class="destination-item" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500" data-aos-offset="50">
                            <div class="image">
                                <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                                <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                <img src="https://images.pexels.com/photos/2662086/pexels-photo-2662086.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                            </div>
                            <div class="content">
                                <span class="location"><i class="fal fa-map-marker-alt"></i> Wildest, Italy</span>
                                <h5><a href="/Destination">Blue lake water view taken travel with daytime</a></h5>
                                <span class="time">3 days 2 nights - Couple</span>
                            </div>
                            <div class="destination-footer">
                                <span class="price"><span>$63.00</span>/per person</span>
                                <a href="#" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-4 col-md-6">
                        <div class="destination-item" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
                            <div class="image">
                                <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                                <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                <img src="https://images.pexels.com/photos/2132126/pexels-photo-2132126.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                            </div>
                            <div class="content">
                                <span class="location"><i class="fal fa-map-marker-alt"></i> Rome, Italy</span>
                                <h5><a href="/Destination">Woman standing near Colosseum, Rome</a></h5>
                                <span class="time">3 days 2 nights - Couple</span>
                            </div>
                            <div class="destination-footer">
                                <span class="price"><span>$42</span>/per person</span>
                                <a href="#" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-4 col-md-6">
                        <div class="destination-item" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1500" data-aos-offset="50">
                            <div class="image">
                                <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                                <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                <img src="https://images.pexels.com/photos/586687/pexels-photo-586687.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                            </div>
                            <div class="content">
                                <span class="location"><i class="fal fa-map-marker-alt"></i> Rome, Italy</span>
                                <h5><a href="/Destination">Woman standing near Colosseum, Rome</a></h5>
                                <span class="time">3 days 2 nights - Couple</span>
                            </div>
                            <div class="destination-footer">
                                <span class="price"><span>$52.00</span>/per person</span>
                                <a href="#" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    </div>
  )
}

export default Destination_Area
